'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import { Map as ImmutableMap } from 'immutable';
import { changeFilters } from 'AdsUI/actions/GlobalFilterActions';
import { fetchUsersInfo, fetchTeamsInfo } from 'AdsUI/actions/UsersAndTeamsActions';
import { getSelectedUsersAndTeams } from 'AdsUI/selectors/GlobalFilters';
import { getUsersInfo, getTeamsInfo, getUsersInfoRequestStatus, getTeamsInfoRequestStatus } from 'AdsUI/selectors/UsersAndTeamsSelectors';
import { hasContentTeamAssignmentScope, getHubSpotUserId } from 'AdsUI/selectors/AuthSelectors';
import { getAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
import UsersAndTeamsSelect from 'ui-asset-management-lib/components/tableFilters/UsersAndTeamsSelect';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { USERS_AND_TEAMS_TYPE } from 'AdsUI/lib/Constants';
import { usageTracker } from 'AdsUI/lib/usageTracker';

const GlobalUsersAndTeamsFilterContainer = ({
  selectedUsersAndTeams,
  usersInfo,
  teamsInfo,
  usersInfoStatus,
  teamsInfoStatus,
  contentTeamAssignmentScope,
  hubspotUserId,
  adAccounts,
  dispatch
}) => {
  useEffect(() => {
    dispatch(fetchUsersInfo());
    dispatch(fetchTeamsInfo());
  }, [dispatch]);
  const requestsLoading = !usersInfoStatus.fetched || !teamsInfoStatus.fetched;
  const requestsError = usersInfoStatus.fetchFailed || teamsInfoStatus.fetchFailed;
  const updateUsersAndTeamsFilter = useCallback(selectedFilter => {
    usageTracker.track('usersAndTeamsAction', {
      action: 'Selects users and teams',
      selectedType: selectedFilter.type,
      selectedId: selectedFilter.id.toString()
    });
    dispatch(changeFilters({
      usersAndTeams: ImmutableMap(selectedFilter)
    }));
  }, [dispatch]);

  const getAssignedIdsByType = assigneeType => adAccounts.map(account => account.getAssignedIdsForType(assigneeType)).reduce((result, assignees) => result.concat(assignees), []);

  const assignedTeamIds = getAssignedIdsByType(USERS_AND_TEAMS_TYPE.TEAM);
  const assignedUserIds = getAssignedIdsByType(USERS_AND_TEAMS_TYPE.USER);

  const getTeamsChildrenAsFlatList = (team, depth) => {
    if (team.childTeams.length === 0) {
      return Object.assign({
        depth
      }, team);
    }

    return team.childTeams.reduce((list, childTeam) => list.concat(getTeamsChildrenAsFlatList(childTeam, depth + 1)), [Object.assign({
      depth
    }, team)]);
  };

  const isChildTeamAssigned = (userId, team) => !!team.childTeams.length && getTeamsChildrenAsFlatList(team, 0).find(childTeam => childTeam.userIds.includes(userId) || childTeam.secondaryUserIds.includes(userId));

  const myTeams = teamsInfo.filter(team => (team.userIds.includes(hubspotUserId) || team.secondaryUserIds.includes(hubspotUserId) || isChildTeamAssigned(hubspotUserId, team)) && assignedTeamIds.includes(team.id));
  const users = usersInfo.filter(user => assignedUserIds.includes(user.id));

  if (!contentTeamAssignmentScope && (myTeams.size === 1 && myTeams.get(0).childTeams.length === 0 || myTeams.size === 0)) {
    return null;
  }

  return /*#__PURE__*/_jsx(UIInlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "usersAndTeamsFilter.filterLabel"
    }),
    children: /*#__PURE__*/_jsx(UsersAndTeamsSelect, {
      className: "p-left-0",
      requestsLoading: requestsLoading,
      requestsError: requestsError,
      assetTypeDisplayName: "",
      teams: myTeams.toArray(),
      users: users.toArray(),
      onChange: updateUsersAndTeamsFilter,
      showUnassigned: false,
      value: selectedUsersAndTeams.get('id'),
      searchPlaceholder: I18n.text('usersAndTeamsFilter.searchPlaceholder'),
      customTeamOptionDisabled: false,
      additionalOptions: [],
      userHasTeamAssignmentScope: contentTeamAssignmentScope
    })
  });
};

function mapStateToProps(state) {
  return {
    selectedUsersAndTeams: getSelectedUsersAndTeams(state),
    usersInfo: getUsersInfo(state),
    teamsInfo: getTeamsInfo(state),
    usersInfoStatus: getUsersInfoRequestStatus(state),
    teamsInfoStatus: getTeamsInfoRequestStatus(state),
    contentTeamAssignmentScope: hasContentTeamAssignmentScope(state),
    hubspotUserId: getHubSpotUserId(state),
    adAccounts: getAdAccounts(state)
  };
}

export default connect(mapStateToProps)(GlobalUsersAndTeamsFilterContainer);